(function ($, document, window) {
	'use strict';

	function checkIfOpenerNavNeeded(lockOrUnlock, sliderElement, nav, bottomNav) {
		if ('lock' === lockOrUnlock) {
			nav.addClass('opener-card-collection__carousel-nav--hidden');
			bottomNav.addClass('opener-card-collection__nav--hidden');

			sliderElement.removeAttribute('role');
			sliderElement.removeAttribute('aria-label');
			sliderElement.removeAttribute('aria-roledescription');
		} else if ('unlock' === lockOrUnlock) {
			nav.removeClass('opener-card-collection__carousel-nav--hidden');
			bottomNav.removeClass('opener-card-collection__nav--hidden');

			sliderElement.setAttribute('role', 'region');
			sliderElement.setAttribute('aria-label', 'Posts Carousel');
			sliderElement.setAttribute('aria-roledescription', 'carousel');
		}
	}

	$(function () {
		$('.js-opener-card-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navsContainer = $('.js-opener-card-carousel-nav', sliderContainer);
			const paginationEl = $('.js-opener-card-carousel-pagination', sliderContainer)[0];
			const bottomNav = $('.js-opener-card-carousel-navs', sliderContainer);
			const buttons = $('.js-opener-card-opener', sliderContainer);

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 16,
				slidesPerView: 'auto',
				loop: false,
				watchOverflow: true,
				updateOnWindowResize: true,
				focusableElements: 'input, select, option, textarea, video, label',

				pagination: {
					el: paginationEl,
					type: 'bullets',
					clickable: true,
					bulletClass: 'opener-card-collection__pagination-bullet pagination-bullet',
					bulletActiveClass: 'pagination-bullet--active'
				},

				on: {
					lock: function () {
						checkIfOpenerNavNeeded('lock', sliderEl, navsContainer, bottomNav);
					},

					unlock: function () {
						checkIfOpenerNavNeeded('unlock', sliderEl, navsContainer, bottomNav);
					},

					slideChange: function () {
						if (this.isBeginning) {
							$('.js-carousel-nav-prev', sliderContainer).addClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-prev', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-prev', sliderContainer).removeClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-prev', sliderContainer).removeAttr('disabled');
						}

						if (this.isEnd) {
							$('.js-carousel-nav-next', sliderContainer).addClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-next', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-next', sliderContainer).removeClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-next', sliderContainer).removeAttr('disabled');
						}
					},
				},
			});

			buttons.each(function () {
				const parentSlide = $(this).closest('.js-carousel-slide');
				const slideIndex = parentSlide.index();

				$(this).on('click', function (e) {
					if (slideIndex !== swiper.activeIndex) {
						setTimeout(() => {
							swiper.update();
							swiper.slideTo(slideIndex);
						}, 350);
					}
				});
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		});
	});
})(jQuery, document, window);
